import React, { useState } from "react";
import { Box } from "@material-ui/core";
import {
  CreateAgentRotationScheme,
  GetSuitableAgentsForRotationScheme,
} from "../../../../../Services";
import {
  CustomAsyncAutocomplete,
  CustomDialog,
  ReskinningInputs,
} from "../../../../../Components";
import { calculateCapacities } from "../../../AgentsView/AgentsDialogsView/capacityUtils";
import { useTranslate } from "../../../../../Hooks";

import useStyles from "../styles";

function AddAgentDialog({ schemaId, isOpen, onClose, getAllAgent }) {
  const styles = useStyles();
  const { translate } = useTranslate("NewAgentsRotationCriteria");
  const [agentValues, setAgentValues] = useState({
    agentIds: [],
    agentLeadCapacityInRotation: 0,
    dailyCapacity: 0,
    monthlyCapacity: 0,
    weeklyCapacity: 0,
  });
  const isDisabled = !agentValues.agentIds.length;

  const updateCapacity = (type, value) => {
    const capacities = calculateCapacities(type, value);
    setAgentValues({
      ...agentValues,
      ...capacities,
    });
  };

  return (
    <div>
      <CustomDialog
        paperClassName={styles.dialogWrapper}
        open={isOpen}
        onClose={() => {
          onClose(false);
        }}
        onConfirm={async () => {
          //   add agent
          if (agentValues) {
            const res = await CreateAgentRotationScheme(schemaId, {
              ...agentValues,
            });
            if (!(res && res.status && res.status !== 200)) {
              getAllAgent();
            }
          }
          onClose(false);
        }}
        content={
          <>
            <CustomAsyncAutocomplete
              labelValue={translate("agent-name")}
              rootCustomClasses={styles.inputwrapper}
              value={agentValues.agentLeadCapacityInRotation}
              onChange={(_e, value) => {
                const ids = value.map(({ agentId }) => agentId);
                setAgentValues({ ...agentValues, agentIds: ids });
              }}
              mapper={(data) => {
                return data.map((item) => item);
              }}
              queryKey={"search"}
              onFetchData={(filter) =>
                GetSuitableAgentsForRotationScheme(1, 1000, filter)
              }
              filter={{ search: null }}
              displayLabel={(option) => option?.agentName ?? ""}
              renderOption={(option) => option?.agentName}
              chipsLabel={(option) => {
                return option?.agentName;
              }}
              getOptionSelected={(option, value) =>
                option?.agentId === value?.agentId
              }
              multiple
              //   refetchOnSearch
            />
            <Box display={"flex"} className={styles.wrapperContainer}>
              <div>
                <label className={styles.capacityLabel}>
                  {translate("lead-capacity")}
                </label>
                <p>{translate("lead-capacity-subtext")}</p>
              </div>
              <Box
                display={"flex"}
                flexDirection={"coulmn"}
                className={styles.capacityFieldsContainer}
              >
                <ReskinningInputs
                  fieldClasses={styles.inputwrapper}
                  rootCustomClasses={styles.inputwrapper}
                  value={agentValues.agentLeadCapacityInRotation}
                  onInputChanged={(e) => {
                    updateCapacity(
                      "agentLeadCapacityInRotation",
                      e.target.value
                    );
                  }}
                  inputPlaceholder={translate("over-all-capacity-placeholder")}
                  type="number"
                />
                <ReskinningInputs
                  fieldClasses={styles.inputwrapper}
                  rootCustomClasses={styles.inputwrapper}
                  value={agentValues.monthlyCapacity}
                  onInputChanged={(e) => {
                    updateCapacity("monthlyCapacity", e.target.value);
                  }}
                  inputPlaceholder={translate("monthly-capacity-placeholder")}
                  type="number"
                />
                <ReskinningInputs
                  fieldClasses={styles.inputwrapper}
                  rootCustomClasses={styles.inputwrapper}
                  type="number"
                  value={agentValues.weeklyCapacity}
                  onInputChanged={(e) => {
                    updateCapacity("weeklyCapacity", e.target.value);
                  }}
                  inputPlaceholder={translate("weekly-capacity-placeholder")}
                />
                <ReskinningInputs
                  fieldClasses={styles.inputwrapper}
                  rootCustomClasses={styles.inputwrapper}
                  type="number"
                  value={agentValues.dailyCapacity}
                  onInputChanged={(e) => {
                    updateCapacity("dailyCapacity", e.target.value);
                  }}
                  inputPlaceholder={translate("daily-capacity-placeholder")}
                />
              </Box>
            </Box>
          </>
        }
        title={translate("assign-new-agent")}
        subtitle={translate("agent-form-sub-text")}
        cancelText={translate("cancel")}
        confirmText={translate("add")}
        isDisabled={isDisabled}
      />
    </div>
  );
}

export default AddAgentDialog;
